import { QRCodeSVG } from "qrcode.react";
import styles from "./PilotStudyFinish.module.css";

const PilotStudyFinishPage = () => {
  return (
    <div className={styles.wrapper}>
      <main className={styles.content}>
        <div className={styles.heading}>
          <h1>Thank you for participating in our SONA pilot study!</h1>
          <p>
            We do not yet have a public-ready version of the Psychology Pathways
            site, but we are hoping to release one to CSUF students in 2027.
          </p>
        </div>

        <div className={styles.socials}>
          <p>
            Please follow our social media to be notified when we release the
            Psychology Pathways site to the CSUF community!
          </p>
          <div className={styles.qrCodes}>
            <QRCodeSVG
              value={import.meta.env.VITE_LINKEDIN_URL}
              title="Psychology Pathways LinkedIn"
              size={128}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              imageSettings={{
                src: "/icons/linkedin.svg",
                height: 28,
                width: 28,
                opacity: 1,
                excavate: true,
              }}
            />

            <QRCodeSVG
              value={import.meta.env.VITE_INSTAGRAM_URL}
              title="Psychology Pathways Instagram"
              size={128}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              imageSettings={{
                src: "/icons/instagram.svg",
                height: 28,
                width: 28,
                opacity: 1,
                excavate: true,
              }}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default PilotStudyFinishPage;
